import React from 'react';
import { Link } from 'react-router-dom';
import { PageTitle } from '../components/PageTitle';
import { HomeIcon } from 'lucide-react';
export function NotFound() {
  return <div className="bg-white min-h-screen" data-id="element-1362">
      <PageTitle title="Page Not Found" description="The page you are looking for does not exist or has been moved." data-id="element-1363" />
      <div className="container mx-auto px-4 py-20 text-center" data-id="element-1364">
        <h1 className="text-6xl font-bold text-[#0096B4] mb-4" data-id="element-1365">404</h1>
        <h2 className="text-3xl font-semibold text-gray-800 mb-6" data-id="element-1366">
          Page Not Found
        </h2>
        <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto" data-id="element-1367">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="inline-flex items-center bg-[#0096B4] hover:bg-[#00778F] text-white px-6 py-3 rounded-md font-medium transition-colors duration-200" data-id="element-1368">
          <HomeIcon size={18} className="mr-2" data-id="element-1369" />
          Back to Home
        </Link>
      </div>
    </div>;
}